import React from "react";
import { Button, Row, Form } from "react-bootstrap";
import Dropzone from "react-dropzone";

const ImageUploadField = ({
  label = "Upload Image",
  imageUrl = "",
  onDrop,
  onDelete,
  disabled = false,
  accept,
  maxSize,
}) => {
  return (
    <Form.Group>
      <label>{label}</label>
      <Row style={{ marginLeft: 0 }}>
        <Dropzone
          onDrop={onDrop}
          accept={accept}
          maxSize={maxSize}
          multiple={false}
          disabled={disabled}
        >
          {({ getRootProps, getInputProps }) => (
            <section style={{ padding: 0 }}>
              <div {...getRootProps()}>
                <input {...getInputProps()} />
                <Button
                  size="small"
                  variant="contained"
                  color="primary"
                  disabled={disabled}
                >
                  {"Upload File"}
                </Button>
              </div>
            </section>
          )}
        </Dropzone>
        {imageUrl && (
          <Button
            className="btn-link btn-icon"
            type="button"
            variant="success"
            onClick={onDelete}
            disabled={disabled}
          >
            <i className="fas fa-trash"></i>
          </Button>
        )}
      </Row>
      <Form.Control
        value={imageUrl || ""}
        placeholder="Image Link"
        type="string"
        disabled
        style={{ marginTop: 5, marginBottom: 5 }}
      />
      {imageUrl && (
        <img src={imageUrl} height="100" width="150" alt="preview" />
      )}
    </Form.Group>
  );
};

export default ImageUploadField;
